<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">会员详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回会员管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsMembers'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <th width="20%" align="center">会员头像</th>
                <th width="20%" align="center">会员名称</th>
                <th width="20%" align="center">会员类型</th>
                <th width="20%" align="center">系统标签</th>
                <th width="20%" align="center">状态</th>
            </tr>
            <tr>
                <td align="center"><el-image :src="memberinfo.thumb" fit="cover" class="ttl-member-avar" /></td>
                <td align="center">
                    <div class="member-phones">
                        <span>{{memberinfo.name}}</span>
                        <wcimage class="phone-copy left10" :option="{size:'mini'}" :value="require('@/assets/icon/copy.png')"  @click="$method.COPY_TEXT({title:memberinfo.name}) "/>
                    </div>
                </td>
                <td align="center">{{memberinfo.iscompany}}</td>
                <td align="center">{{memberinfo.isrobotname}}</td>
                <td align="center">
                    <span v-if="memberinfo.isfrozen===0">正常</span>
                    <div class="ttl-member-status" v-if="memberinfo.isfrozen===1 || memberinfo.isfrozen===2">
                        <span>{{memberinfo.isfrozen===1 ? '被冻结' : '被举报'}}</span>
                        <el-tooltip placement="top">
                        <template #content>{{memberinfo.frozen_reason}}<br />{{memberinfo.frozen_time}}</template>
                        <el-image :src="require('@/assets/icon/wrong.png')" class="ttl-frozen left10" />  
                        </el-tooltip>
                    </div>
                </td>
            </tr>
            <tr>
                <th width="20%" align="center">会员手机</th>
                <th width="20%" align="center">闲置数量</th>
                <th width="20%" align="center">求购数量</th>
                <th width="20%" align="center">收藏数量</th>
                <th width="20%" align="center">关注会员数量</th>
            </tr>
            <tr>
                <td align="center">
                    <div class="member-phones">
                        <span>{{memberinfo.phone}}</span>
                        <wcimage class="phone-copy left10" :option="{size:'mini'}" :value="require('@/assets/icon/copy.png')"  @click="$method.COPY_TEXT({title:memberinfo.phone}) "/>
                    </div>
                </td>
                <td align="center"><div class="numbers" @click="GetSearchData(1)">{{memberinfo.sales}}</div></td>
                <td align="center"><div class="numbers" @click="GetSearchData(2)">{{memberinfo.buys}}</div></td>
                <td align="center"><div class="numbers" @click="GetSearchData(3)">{{memberinfo.collects}}</div></td>
                <td align="center"><div class="numbers" @click="GetSearchData(4)">{{memberinfo.attentions}}</div></td>
            </tr>

        </table>
    </div>
            
</div>

<!-- 商品列表搜索 -->
<GoodsSearch :view="goodsview" :option="goodsoption" @finish="(val)=> {this.goodsview=false}"/>
<!-- 关注会员 -->
<MembersSearch :view="memberview" :option="memberoption" @finish="(val)=> {this.memberview=false}"/>

</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
import GoodsSearch from '@/views/EsGoods/GoodsSearch';
import MembersSearch from '@/views/EsMembers/MembersSearch';

export default {
    components:{
        GoodsSearch,MembersSearch
    },
    data() {
        return {
            LoadingObj:'MemberDetail',  //loading对象   
            memberinfo:{}, //商品信息 
            goodsview:false,
            goodsoption:{
                type:'',
                memberid:'',
            },
            memberview:false,
            memberoption: {
                type:'',
                memberid:'',
            }


        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetMemberInfo(data.param.id);
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetMemberInfo(data.param.id);
            } 
        },


        /** 获取商品信息详情 **/
        GetMemberInfo(id) {
            var obj=this.$refs[this.LoadingObj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.GET_MEMBER_INFO({id:id}).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.memberinfo=res.data[0];
            });
        },


        /** 数据搜索 **/
        GetSearchData(type) {
            if(type==1) {
                this.goodsoption.type='sale';
                this.goodsoption.memberid=this.memberinfo.id;
                this.goodsview=true;
            }else if(type==2) {
                this.goodsoption.type='buy';
                this.goodsoption.memberid=this.memberinfo.id;
                this.goodsview=true;
            }else if(type==3) {
                this.goodsoption.type='collect';
                this.goodsoption.memberid=this.memberinfo.id;
                this.goodsview=true;
            }else if(type==4) {
                this.memberoption.type='attention';
                this.memberoption.memberid=this.memberinfo.id;
                this.memberview=true;
            }
            
        }
        


    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;}
.numbers {color:#666eeb;cursor: pointer;}
.member-phones {display: inline-flex;justify-content: center;align-items: center;}
.phone-copy {cursor: pointer;}
</style>